import { SafeString } from 'handlebars';
import { HawksearchGlobal, QuerySuggestionsData } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../base.component';
import defaultHtml from './query-suggestions.component.hbs';

declare let Hawksearch: HawksearchGlobal;

export class QuerySuggestionsComponent extends BaseComponent<QuerySuggestionsData> {
    protected override bindEvent = 'hawksearch:bind-query-suggestions';
    protected override customTemplatePropertyName = 'querySuggestions';
    protected override defaultHtml = defaultHtml;

    protected override registerHelpers(): void {
        super.registerHelpers();

        this.handlebars.registerHelper('query-suggestions', function (querySuggestions: Array<string>): SafeString {
            function linkFunction(query: string): string {
                return `<a hawksearch-query="${encodeURIComponent(query)}" class="query-suggestions__link">${query}</a>`;
            }

            if (querySuggestions.length <= 2) {
                return new Hawksearch.handlebars.SafeString(querySuggestions.map(linkFunction).join(' or '));
            }

            const generalDelimeter = ', ';
            const lastDelimeter = ', or ';

            return new Hawksearch.handlebars.SafeString(
                querySuggestions
                    .slice(0, querySuggestions.length - 1)
                    .map(linkFunction)
                    .join(generalDelimeter) +
                    lastDelimeter +
                    linkFunction(querySuggestions[querySuggestions.length - 1])
            );
        });
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.data.display || !this.data.querySuggestions?.length) {
            return '';
        }

        const html = template({
            querySuggestions: this.data.querySuggestions
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
